export default "__VITE_ASSET__BBIuWMkY__"